import RegionImageActions from './regionImageActions';
import { Box, Grid } from '@mui/material';
import '../../../css/sites/siteDetailsContent.css';

const RegionDetailsContent = () => {
  return (
    <Grid container spacing={3} className='siteDetailsContent_main_grid'>
      <Grid item xs={12} md={4} padding={3}>
        <Box className='siteDetailsContent_image_chiffre_box'>
          <RegionImageActions />
        </Box>
      </Grid>
    </Grid>
  );
}

export default RegionDetailsContent;